import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import {
	Bar,
	BarChart,
	CartesianGrid,
	Legend,
	ResponsiveContainer,
	Tooltip,
	XAxis,
	YAxis
} from "recharts";
import { useLazyGetMonthlyLeaseExpirationsQuery } from "../store/reports.query";

// Prepare your lease data
// const leasePaymentsData = [
// 	{ name: "Jan 2025", collected: 759000, expected: 683100 },
// 	{ name: "Apr 2025", collected: 0, expected: 105000 },
// 	{ name: "May 2025", collected: 36000, expected: 81000 },
// 	{ name: "Jun 2025", collected: 0, expected: 1620000 },
// 	{ name: "Jul 2025", collected: 2034120, expected: 2034120 },
// 	{ name: "Sep 2025", collected: 118800, expected: 1306800 },
// 	{ name: "Oct 2025", collected: 907200, expected: 907200 },
// 	{ name: "Dec 2025", collected: 150000, expected: 150000 },
// ];

const MonthlyLeasePayments = () => {

	const [leasePaymentsData, setLeasePaymentsData] = useState()

	//@ts-ignore
	const transformLeasePayments = (apiData) => {
		const byMonth = apiData.summary.byMonth;

		const leasePaymentsData = Object.entries(byMonth).map(
			//@ts-ignore
			([month, { collected, expected }]) => ({
				name: formatMonth(month),
				collected: parseFloat(collected),
				expected: parseFloat(expected),
			})
		);

		return leasePaymentsData;
	};

	// Optional: shorten month name for cleaner chart labels
	//@ts-ignore
	const formatMonth = (monthString) => {
		// Input: "January 2025", Output: "Jan 2025"
		const [month, year] = monthString.split(" ");
		return `${month.slice(0, 3)} ${year}`;
	};

	const [getLeaseExpirations, leaseExpirations] = useLazyGetMonthlyLeaseExpirationsQuery()

	useEffect(() => {

		getLeaseExpirations({})

	}, [])

	useEffect(() => {

		if(leaseExpirations?.data?.summary?.byMonth){
			//@ts-ignore
			setLeasePaymentsData(transformLeasePayments(leaseExpirations?.data))
		}

	}, [leaseExpirations])
	return (
		<motion.div
			className='bg-gray-800 bg-opacity-50 backdrop-blur-md  shadow-lg rounded-xl p-6 border border-gray-700'
			initial={{ opacity: 0, y: 20 }}
			animate={{ opacity: 1, y: 0 }}
			transition={{ delay: 0.4 }}
		>
			<h2 className='text-xl font-semibold text-gray-100 mb-4'>
				Monthly Lease Payments
			</h2>

			<div style={{ width: "100%", height: 300 }}>
				
				<ResponsiveContainer >
					<BarChart data={leasePaymentsData}>
						<CartesianGrid strokeDasharray='3 3' stroke='#374151' />
						<XAxis dataKey='name' stroke='#9CA3AF' />
						<YAxis stroke='#9CA3AF' />
						<Tooltip
							contentStyle={{ backgroundColor: "rgba(31, 41, 55, 0.8)", borderColor: "#4B5563" }}
							itemStyle={{ color: "#bbb" }}
						/>
						<Legend />
						<Bar type='monotone' dataKey='collected' stroke='#8B5CF6' fill='#8B5CF6' fillOpacity={0.3}  />
						<Bar type='monotone' dataKey='expected' stroke='#10B981' fill='#10B981' fillOpacity={0.3} />
					</BarChart>
					{/* <AreaChart data={leasePaymentsData}>
						<CartesianGrid strokeDasharray='3 3' stroke='#374151' />
						<XAxis dataKey='name' stroke='#9CA3AF' />
						<YAxis stroke='#9CA3AF' />
						<Tooltip
							contentStyle={{ backgroundColor: "rgba(31, 41, 55, 0.8)", borderColor: "#4B5563" }}
							itemStyle={{ color: "#E5E7EB" }}
						/>
						<Legend />
						<Area type='monotone' dataKey='collected' stroke='#8B5CF6' fill='#8B5CF6' fillOpacity={0.3} />
						<Area type='monotone' dataKey='expected' stroke='#10B981' fill='#10B981' fillOpacity={0.3} />
					</AreaChart> */}
				</ResponsiveContainer>
			</div>
		</motion.div>
	);
};

export default MonthlyLeasePayments;
